/* 馬超傳共用的小工具：關西的兵、史書上有名但不是可選武將的人、帶兵、許褚的視線扇形
 * （只給 machao*.ts 用；機制寫在這裡，不動 campaign/kit.ts） */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { H } from '../../heroes/define.ts';
import { troop, TROOPS } from '../kit.ts';

// 關西的兵（西涼騎）、袁軍（郭援、高幹）、益州兵
export const XL = troop('xiliang', '西涼騎', { armor: '#5a6a3a', sleeve: '#3a4a2a', cloth: '#3a4a2a', plume: '#a0b060' });
export const YUAN = TROOPS.yuan;
export const YI = troop('yizhou-soldier', '益州兵', { armor: '#6a5a7a', sleeve: '#4a3e58', cloth: '#4a3e58', plume: '#a090c0' });

// 不是可選武將的人：通用招式（中立的人墊一套暗色的底）
const NEUTRAL_C = { armor: '#5a4a3a', sleeve: '#3a3028', cloth: '#3a3028', trim: '#b8a060', pants: '#2a2420', boot: '#2a2018', cape: null, belt: '#5a3a22', metal: '#8e979f', hood: '#3a3028', pole: '#5a3a22', plume: '#b8a060', band: '#b8a060' };
const P = (id, name, sub, role, weapon, look, n) => H(id, name, sub, 'neutral', role, weapon, Object.assign({ fx: '#ffd8a0' }, look, { c: Object.assign({}, NEUTRAL_C, look.c) }), [
  ['揮擊', 'crescent', `造成 {${n}/${n}/${n}/${n}} 傷害。`], ['衝陣', 'charge', `衝撞造成 {${n}/${n}/${n}/${n}} 傷害。`], ['迴斬', 'spin', `每圈 {${n >> 1}/${n >> 1}/${n >> 1}/${n >> 1}} 傷害。`], ['猛擊', 'slam', `{${n * 1.5}/${n * 1.5}/${n * 1.5}} 傷害。`]]);
const XLC = { armor: '#5a6a3a', cloth: '#3a4a2a', cape: '#6a7a40', plume: '#a0b060' };
export const MEN = {
  guoyuan: P('mc-guoyuan', '郭援', '袁尚河東太守', '戰士', 'sword', { eye: 'fierce', beard: 'bushy', bulk: 1.15, size: 1.1, c: { armor: '#7a5a2a', cloth: '#5a4220', cape: '#a07830', plume: '#d0a040' } }, 90),
  gaogan: P('mc-gaogan', '高幹', '并州刺史', '戰士', 'spear', { beard: 'goatee', c: { armor: '#6a4a2a', cloth: '#4a3a20', cape: '#906820', plume: '#c09030' } }, 70),
  hansui: P('mc-hansui', '韓遂', '字文約', '戰士', 'sword', { beard: 'long', hair: '#cfc8bc', c: XLC }, 70),
  chengyi: P('mc-chengyi', '成宜', '關西十部', '戰士', 'spear', { beard: 'bushy', c: XLC }, 60),
  likan: P('mc-likan', '李堪', '關西十部', '戰士', 'axe', { beard: 'mustache', c: XLC }, 60),
  yangqiu: P('mc-yangqiu', '楊秋', '關西十部', '戰士', 'sword', { c: XLC }, 60),
  liangxing: P('mc-liangxing', '梁興', '關西十部', '戰士', 'axe', { eye: 'fierce', beard: 'bushy', c: XLC }, 60),
  zhuling: P('mc-zhuling', '朱靈', '曹操部將', '戰士', 'spear', { beard: 'mustache', c: { armor: '#3b5a99', cloth: '#2a3e6a', cape: '#3b5a99', plume: '#6a8ac0' } }, 80),
  yangfu: P('mc-yangfu', '楊阜', '字義山', '戰士', 'sword', { head: 'guan', beard: 'goatee', c: { armor: '#4a5a6a', cloth: '#3a4652', cape: '#5a6a7a', plume: '#8a9aaa' } }, 80),
  jiangxu: P('mc-jiangxu', '姜敘', '撫夷將軍', '戰士', 'spear', { beard: 'mustache', c: { armor: '#4a5a6a', cloth: '#3a4652', cape: '#5a6a7a', plume: '#8a9aaa' } }, 70),
};

// 帶一隊兵：n 個跟著 lead 走的西涼騎
export function band(m, lead, n, name = '西涼騎', o) {
  return Array.from({ length: n }, (_, i) => {
    const u = m.recruit(lead.x - 80 - (i % 4) * 50, lead.y - 70 + Math.floor(i / 4) * 80, name);
    u.spec = XL; Object.assign(u, o || {}); if (o && o.hp) u.maxHp = o.hp;
    m.join(u, lead);
    return u;
  });
}

// 視線扇形：從 (x, y) 朝 a（弧度，地面度量）看，半角 half、距離 r；u 在不在裡面
export function inCone(c, u) {
  const dx = u.x - c.x, dy = (u.y - c.y) / SG.K, d = Math.hypot(dx, dy);
  if (d > c.r) return false;
  let da = Math.atan2(dy, dx) - c.a;
  while (da > Math.PI) da -= Math.PI * 2;
  while (da < -Math.PI) da += Math.PI * 2;
  return Math.abs(da) < c.half;
}
// 把角度 a 往 to 轉，每秒最多 rate 弧度
export function turn(a, to, rate, dt) {
  let da = to - a;
  while (da > Math.PI) da -= Math.PI * 2;
  while (da < -Math.PI) da += Math.PI * 2;
  return a + Math.max(-rate * dt, Math.min(rate * dt, da));
}
export const angleTo = (a, b) => Math.atan2((b.y - a.y) / SG.K, b.x - a.x);
// 畫視線扇形（地面上半透明的扇）
export function drawCone(ctx, c, col, alpha) {
  ctx.save();
  ctx.globalAlpha = alpha; ctx.fillStyle = col;
  ctx.beginPath(); ctx.moveTo(c.x, c.y);
  for (let i = 0; i <= 16; i++) { const a = c.a - c.half + (i / 16) * c.half * 2; ctx.lineTo(c.x + Math.cos(a) * c.r, c.y + Math.sin(a) * c.r * SG.K); }
  ctx.closePath(); ctx.fill();
  ctx.globalAlpha = Math.min(1, alpha * 2.5); ctx.strokeStyle = col; ctx.lineWidth = 3; ctx.stroke();
  ctx.restore();
}
// 畫一條數值條（信任、恐慌）在世界座標上
export function bar(ctx, x, y, k, col, label) {
  ctx.save();
  ctx.fillStyle = 'rgba(0,0,0,.6)'; ctx.fillRect(x - 46, y, 92, 10);
  ctx.fillStyle = col; ctx.fillRect(x - 45, y + 1, 90 * Math.max(0, Math.min(1, k)), 8);
  if (label) { ctx.font = '900 15px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'bottom'; ctx.lineWidth = 4; ctx.strokeStyle = 'rgba(0,0,0,.75)'; ctx.strokeText(label, x, y - 2); ctx.fillStyle = '#f2e6c8'; ctx.fillText(label, x, y - 2); }
  ctx.restore();
}
// 夜色
export function night(ctx, x0, y0, vw, vh, a = 0.5) { ctx.fillStyle = `rgba(12,18,48,${a})`; ctx.fillRect(x0, y0, vw, vh); }
// 單位倒下：武將會復活，這裡只記「倒下過」
export const down = (u) => !u || !u.alive || u.hp <= 0;
